document.addEventListener('DOMContentLoaded', function () {
  $('.shopify-section-header-sticky').css('position', 'unset');
  let target = $('.ann_banner_container .banner_navs').offset().top;
  $(window).scroll(function () {
    let scrollTop = $(window).scrollTop();
    if (scrollTop >= target) {
      $('.ann_banner_container .banner_navs').addClass('fix_top');
    } else if (scrollTop < target) {
      $('.ann_banner_container .banner_navs').removeClass('fix_top');
    }
  });

  let scroll_num = 100;
  if ($(window).width() < 768) {
    scroll_num = $('.ann_banner_container .banner_navs').innerHeight();
  }
  $('.nav_width .nav_item').on('click', function (e) {
    e.stopPropagation();
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    let targetclass = $(this).attr('href').slice(1);
    let targetheight = $(`.${targetclass}`).eq(0).offset().top - scroll_num;
    $('html,body').animate({ scrollTop: targetheight }, 300);
  });

  $('.ann_note_container .note_title').on('click', function () {
    $(this).children('svg').toggleClass('rotate');
    $(this).siblings('.note_content').slideToggle();
  });

  let url_hash = window.location.hash.slice(1);
  if ($(`.${url_hash}`).length > 0) {
    let div_top = $(`.${url_hash}`).offset().top - scroll_num;
    $('html,body').animate({ scrollTop: div_top }, 300);
  }
});

